import { Config } from '@adornis/config/config.js';

export const routeOptimizationConfig = new Config('nsc-route-optimization', {
  TICKETS_BASE_URL: {
    env: true,
    name: 'TICKETS_BASE_URL',
    client: true,
    required: true,
    parse: val => String(val),
  },

  // GOOGLE
  GOOGLE_CLOUD_PROJECT_NAME: {
    env: true,
    name: 'GOOGLE_CLOUD_PROJECT_NAME',
    client: false,
    required: true,
  },

  MAPBOX_PUBLIC_KEY: {
    env: true,
    name: 'MAPBOX_PUBLIC_KEY',
    client: true,
    required: false,
    defaultVal: ""
  },
});
